import { Box, useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useState } from 'react';

import useAttachmentPreviewStyles from './attachmentPreviewStyles';
import VisibilityIcon from '@material-ui/icons/Visibility';

import Calendar from "../../assets/calendar.png";
import BaseModal from '../BaseModal';
import { GalleryModal } from '../Gallery';

import ReactTimeAgo from 'react-time-ago';
import MovieIcon from '@material-ui/icons/Movie';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

// import TimeAgo from 'javascript-time-ago';
// import pt from 'javascript-time-ago/locale/pt.json';

// TimeAgo.addDefaultLocale(pt)

const baseUrl = 'https://cxd.bibi.com:3636';

export function ShowModal({ notice, open, onClose, attachments = [] }) {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const matches = useMediaQuery('(max-width:900px)');
  const caminhos = attachments.map(a => a.CAMINHO);
  const classes = useAttachmentPreviewStyles();

  function getFileType(name) {
    const ext = name?.split('.').pop()?.toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext)) return "image";
    if (["mp4", "mov", "avi", "wmv", "mkv"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    return "other";
  }

  return (
    <BaseModal
      open={open}
      handleClose={() => onClose()}
      cardStyle={{ padding: '0 1rem', width: matches ? '90%' : '50%', minHeight: 0, maxHeight: '90vh', overflowY: 'scroll' }}
      contentStyle={{ padding: '0 8px', fontWeight: 'normal' }}>
      <h1 style={matches ? { fontSize: 20 } : {}}>{notice?.TITULO}</h1>
      <Box textAlign="left" display={"flex"} alignItems={"center"} >
        <img src={Calendar} alt="calendario" />
        <Box ml={1} >
          <Typography component="h1" variant="subtitle2" style={{ color: "#FE5D00", fontSize: 14, fontWeight: 'bold' }}>
            <ReactTimeAgo date={new Date(notice?.DATA_CADASTRO)} />
          </Typography>
        </Box>
      </Box>
      <div dangerouslySetInnerHTML={{ __html: notice?.CONTEUDO }} />

      {/* Anexos */}

      {attachments.length > 0 && (
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', margin: '1rem 0' }}>
          {attachments.map((item, idx) => {
            const type = getFileType(item.CAMINHO);
            const caminho = item.CAMINHO;
            return (
              <div
                key={idx}
                className={classes.root}
                onClick={() => { setGalleryOpen(true); setGalleryIndex(idx); }}
              >
                {type === 'image' ? (
                  <img src={baseUrl + caminho} alt="preview" style={{ width: '100%', maxHeight: '60px', objectFit: 'contain' }} />
                ) : null}
                {type !== 'image' && (
                  <span style={{ fontFamily: 'Nunito', fontWeight: 700, color: '#EC660C', fontSize: 16, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {type === 'video' ? <MovieIcon style={{ fontSize: 32, marginBottom: 4 }} /> : null}
                    {type === 'pdf' ? <PictureAsPdfIcon style={{ fontSize: 32, marginBottom: 4 }} /> : null}
                    {type === 'other' ? 'Arquivo' : null}
                  </span>
                )}
                <span className={classes.eyeOverlay}>
                  <VisibilityIcon style={{ fontSize: 40, color: '#EC660C' }} />
                </span>
              </div>
            );
          })}
        </div>
      )}

      <GalleryModal
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        files={caminhos}
        initialIndex={galleryIndex}
      />

      <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
        <img src="/bibi.svg" alt="logo da bibi" />

      </div>
    </BaseModal>
  )
}